export default "__VITE_ASSET__TNwtLivt__"